import { connectStepper } from "../util/redux";
import FacialRecognition from "../components/facial-recognition";

export default connectStepper(FacialRecognition);
